import React, {useEffect, useState} from "react";
import axios from "axios";

const LMBLogging = () => {
    const [Machines, setMachines] = useState([])
    const [Admin, setAdmin] = React.useState(false);

    let Loggerid

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await axios.get('/api/auth/validate-token', { withCredentials: true });
                const user = response.data.user.organization;
                if (user === "admin") {
                    setAdmin(true)
                }
            } catch (error) {
                console.log(error)
            }
        };

        checkAuth();
    }, []);

    useEffect(() => {
        const getMachines = async () => {
            try {
                const response = await axios.get("/api/berend/get");
                setMachines([...response.data]);
            } catch (error) {
                console.log(error)
            }
        }

        getMachines();
    }, [])

    const DeleteMachine = async () => {
        if (Admin) {
            document.getElementById("popup").style.display = "none";
            window.location.reload();
            await axios.delete(`/api/berend/delete`, {
                params: {
                    loggerid: Loggerid,
                }
            });
        }
    }

    const confirmDeleteMachine = async (event, loggerid) => {
        document.getElementById("popup").style.display = "flex";
        Loggerid = loggerid;
    }

    const cancelDeleteMachine = async () => {
        document.getElementById("popup").style.display = "none";
    }

    return (
        <div className={"flex w-full px-4"}>
            {Admin ? <dialog open id={"popup"}
                             className={"hidden shadow-sm shadow-gray-400 bg-gray-200 rounded-2xl p-3 w-72 fixed z-50 text-center gap-4 flex-col"}>
                <p className={"font-bold text-2xl"}>Weet je zeker dat je deze machine wilt verwijderen</p>
                <div className="flex items-center justify-around">
                    <button className={"p-2 bg-blue-500 rounded-full text-xl font-bold text-white w-16"}
                            onClick={DeleteMachine}>Ja
                    </button>
                    <button className={"p-2 bg-blue-500 rounded-full text-xl font-bold text-white w-16"}
                            onClick={cancelDeleteMachine}>Nee
                    </button>
                </div>
            </dialog> : null}
            <a href={"/"} className={"ml-2 mt-2 font-extrabold text-xl text-white absolute bg-orange-500 rounded-lg h-fit p-1.5 shadow-xl shadow-gray-400"}>Terug</a>
            <ul className={"flex flex-col mt-1 gap-6 w-full px-36"}>
                {Machines.map((machine) => (
                    <li key={machine.loggerid} className={`gap-4 items-center font-medium pb-10 flex text-3xl border-b-2 relative last:border-none border-gray-400`}>
                        <a href={"/lmb-logging/" + machine.alias} className={"rounded-full w-32 h-32 sm:flex hidden bg-gradient-to-br from-yellow-400 to-orange-600 items-center justify-center text-4xl text-white shadow-xl shadow-gray-400"}>
                            {machine.alias ? machine.alias.substring(0, 1) : ""}
                        </a>
                        <div>
                            <a className={"text-gray-800 font-extrabold ml-2"} href={"/lmb-logging/" + machine.alias}>Naam: {machine.alias}</a>
                            <h1 className={"text-gray-700 ml-2 select-none lg:block hidden"}>Serienummer: {machine.loggerid}</h1>
                            <h1 className={"text-gray-700 ml-2 select-none"}>Bedrijf: {machine.cleanorg}</h1>
                        </div>
                        {Admin ? <div className={"flex lg:flex-col sm:absolute bottom-3 flex-row right-3 lg:top-0 text-center gap-4"}>
                            <a onClick={(event) => confirmDeleteMachine(event, machine.loggerid)}
                               className={"hover:cursor-pointer bg-red-600 text-white rounded p-2"}>Delete</a>
                            {/*<a href={"edit/" + serialNumber}*/}
                            {/*   className={"hover:cursor-pointer bg-blue-500 text-white rounded p-2"}>Edit</a>*/}
                        </div> : null}
                    </li>
                ))}
            </ul>
            {Admin ? <a href={"/lmb-logging/nieuw"}
                        className="fixed right-3 bottom-3 w-14 h-14 rounded-full bg-green-600 shadow-xl shadow-gray-400 p-3.5">
                <img src={"/Add.svg"} alt={""}/>
            </a>: ""}
        </div>
    )

}

export default LMBLogging;